﻿import { LOCALE } from '@xplan-pension-switching/common';

export const formatPercentageTwoDecimalPlaces = (value: number | undefined) => {
    if (value === undefined) {
        return '';
    }
    const valueTo2Dp = Intl.NumberFormat(LOCALE, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
    return `${valueTo2Dp} %`;
};
